import { BasePlugin } from '../base'
import mdcIcon from './mdc-icon.vue'

export { mdcIcon }

export default BasePlugin({
  mdcIcon
})
